import { Checkbox, Input, InputNumber, message, Modal } from 'antd';
import axiosInstance from '../../../../../axios/axiosInstance';
import React, { useEffect, useState } from 'react';
import { ModePage } from 'common/enum';
import { GradeRequest } from 'model/request';
import processError from '../../../../../utils/processError';

interface Props {
  isOpen: boolean;
  onCloseModal: () => void;
  mode: ModePage;
  onBeforeSuccess: () => void;
  gradeId: string;
}

export default function GradeFormModal({ isOpen, onCloseModal, mode, onBeforeSuccess, gradeId }: Props) {
  const [newGrade, setNewGrade] = useState<GradeRequest | null>(null);

  const onInputField = (e: any, fieldName: string) => {
    const newGradeTemp = { ...newGrade } as any;
    newGradeTemp[fieldName] = e.target.value;

    setNewGrade(newGradeTemp);
  };

  const onCheckboxField = (e: any, fieldName: string) => {
    const newGradeTemp = { ...newGrade } as any;
    newGradeTemp[fieldName] = e.target.checked;

    setNewGrade(newGradeTemp);
  };

  const loadNewGrade = async () => {
    try {
      const newGrade: GradeRequest = {
        id: '',
        name: '',
        code: '',
        webViewActive: true,
        webViewOrder: 1,
      };
      setNewGrade(newGrade);
    } catch (err) {
      processError(err);
    }
  };

  const loadEditGrade = async () => {
    try {
      const res = await axiosInstance({
        url: `/grades/${gradeId}`,
        method: 'get',
      });

      if (res.status === 200) {
        setNewGrade(res.data);
      } else {
        message.error('Có lỗi xảy ra.');
      }
    } catch (err) {
      processError(err);
    }
  };

  const onOk = async () => {
    if (!newGrade?.name) {
      message.error('Vui lòng nhập tên lớp');
      return;
    }
    if (!newGrade?.webViewOrder && newGrade?.webViewOrder !== 0) {
      message.error('Vui lòng nhập thứ tự hiển thị');
      return;
    }
    try {
      if (newGrade) {
        await axiosInstance({
          url: mode === ModePage.ADD ? '/grades' : `/grades/${newGrade.id}`,
          method: mode === ModePage.ADD ? 'post' : 'put',
          data: newGrade,
        });

        onBeforeSuccess();
        message.success(mode === ModePage.ADD ? `Thêm thành công` : `Sửa thành công`);
      }
    } catch (err) {
      processError(err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      mode === ModePage.ADD ? loadNewGrade() : loadEditGrade();
    }
  }, [isOpen]);

  return (
    <Modal open={isOpen} onOk={onOk} onCancel={onCloseModal}>
      <div className="mt-8">
        <div className="flex items-center gap-2">
          <div className="w-[210px]">
            Tên lớp: <span className={'text-FF1D30'}>*</span>
          </div>
          <Input maxLength={255} name="name" onChange={(e) => onInputField(e, 'name')} value={newGrade?.name} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[210px]">Mã lớp:</div>
          <Input maxLength={255} name="code" onChange={(e) => onInputField(e, 'code')} value={newGrade?.code} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <label>Hiển thị trên web</label> <br />
          <Checkbox checked={newGrade?.webViewActive} onChange={(e) => onCheckboxField(e, 'webViewActive')} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <label>
            Độ ưu tiên hiển thị <span className={'text-FF1D30'}>*</span>
          </label>{' '}
          <br />
          <InputNumber
            placeholder="Nhập độ ưu tiên hiển thị..."
            value={newGrade?.webViewOrder}
            onChange={(e) =>
              newGrade &&
              setNewGrade({
                ...newGrade,
                webViewOrder: e || 1,
              })
            }
            required
          />
        </div>
      </div>
    </Modal>
  );
}
